import { RQAPICallWithData } from 'store/APIClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CSVSharingPayloadT, CSVSharingT } from '../components/types';
import { GET_CSV_SHARINGS_QUERY_KEY } from './getCsvSharings';
import { TableMetadata } from 'routes/Cellar/types';
import { useDispatch } from 'store/hooks';
import { useTranslation } from 'react-i18next';

type TableMetadataWithSharingsT = TableMetadata & CSVSharingPayloadT;

const updateCsvSharings = async (sharing: CSVSharingPayloadT, key: number) => {
    const response = await RQAPICallWithData<TableMetadataWithSharingsT>({
        endpoint: `schema/extension/table/${key}/share`,
        body: sharing,
        method: 'PUT',
    });
    return response.content.data;
};

const useUpdateCsvSharings = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateCsvSharings'],

        mutationFn: ({
            sharing,
            key,
        }: {
            sharing: CSVSharingPayloadT;
            key: number;
        }) => updateCsvSharings(sharing, key),

        onSuccess: (updatedTableMetadata) => {
            queryClient.setQueryData(
                [GET_CSV_SHARINGS_QUERY_KEY, updatedTableMetadata.name],
                (oldSharings: CSVSharingT) => {
                    return {
                        ...oldSharings,
                        usersSharing: updatedTableMetadata.usersSharing,
                        orgSharing: updatedTableMetadata.orgSharing,
                    };
                },
            );
            dispatch.vision.notifyUser({
                message: t('importCSV.rights.updateSuccess'),
                snackType: 'success',
            });
        },
        meta: { useGlobalOnError: true },
    });
};

export default useUpdateCsvSharings;
